/** Estados y transiciones alineados con backend orders.models.Order */

export const ORDER_STATUS_LABELS = {
  pending: 'Pendiente',
  payment_pending: 'Pago pendiente',
  paid: 'Pagado',
  shipped: 'Enviado',
  completed: 'Completado',
  cancelled: 'Cancelado',
}

/** Texto de ayuda para admin (modal de cambio de estado). */
export const ORDER_STATUS_DESCRIPTIONS = {
  pending: 'Pedido recibido; aún no está confirmado el pago ni el despacho.',
  payment_pending: 'El cliente inició el pago online y está pendiente de acreditación.',
  paid: 'Pago confirmado; el pedido está listo para preparar o enviar.',
  shipped: 'El pedido salió en camino. Cambiar el estado no envía emails automáticamente.',
  completed: 'Entrega finalizada; el pedido quedó cerrado correctamente.',
  cancelled: 'Pedido anulado; no se procesa ni se envía.',
}

export const ORDER_STATUS_ICONS = {
  pending: 'fas fa-clock',
  payment_pending: 'fas fa-credit-card',
  paid: 'fas fa-check-circle',
  shipped: 'fas fa-truck',
  completed: 'fas fa-check',
  cancelled: 'fas fa-times',
}

export const ALLOWED_TRANSITIONS = {
  pending: ['payment_pending', 'cancelled', 'paid', 'shipped', 'completed'],
  payment_pending: ['paid', 'cancelled', 'pending', 'shipped', 'completed'],
  paid: ['shipped', 'cancelled', 'pending', 'payment_pending', 'completed'],
  shipped: ['cancelled', 'pending', 'payment_pending', 'paid', 'completed'],
  completed: ['pending', 'payment_pending', 'paid', 'shipped', 'cancelled'],
  cancelled: ['pending', 'payment_pending', 'paid', 'shipped', 'completed'],
}

export function getStatusLabel(status) {
  return ORDER_STATUS_LABELS[status] || status || '—'
}

export function getStatusDescription(status) {
  return ORDER_STATUS_DESCRIPTIONS[status] || ''
}

/** Estados visibles en el panel admin (sin pestaña ni opción de pago pendiente). */
export const ADMIN_STATUS_FILTER_VALUES = [
  'pending',
  'paid',
  'shipped',
  'completed',
  'cancelled',
  'archived',
]

export function matchesPendingFilter(status) {
  return status === 'pending' || status === 'payment_pending'
}

export function getStatusIcon(status) {
  return ORDER_STATUS_ICONS[status] || 'fas fa-circle'
}

export function getAllowedNextStatuses(currentStatus) {
  return ALLOWED_TRANSITIONS[currentStatus] || []
}

export function canArchiveOrder(order) {
  return ['completed', 'cancelled'].includes(order?.status)
}
